export default "__VITE_ASSET__BSIb2R8V__"